interface String {
    toDateTimeLocal(): string;
    toDateLocal(): string;
}

String.prototype.toDateTimeLocal = function (): string {
    const date = new Date(this.toString());
    return date.toLocaleDateString('pt-BR', {
        timeZone: 'America/Sao_Paulo',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });
};

String.prototype.toDateLocal = function (): string {
    const date = new Date(this.toString());
    return date.toLocaleDateString('pt-BR', {
        timeZone: 'America/Sao_Paulo',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
};
